import { useState, useCallback } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export default function useChangeUserPaymentDelayed({ onSettled } = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const changeUserPaymentDelayed = useCallback(
    async (userId, isPaymentDelayed) => {
      if (!userId) {
        setError('User ID is required');
        return false;
      }

      setLoading(true);
      setError(null);

      try {
        await API.put(`/users/${userId}/payment-delayed`, { isPaymentDelayed });

        if (onSettled) {
          onSettled();
        }

        return true;
      } catch (err) {
        setError(translateApiError(err, 'Failed to change delayed-payment status'));

        if (onSettled) {
          onSettled();
        }

        return false;
      } finally {
        setLoading(false);
      }
    },
    [onSettled],
  );

  return {
    changeUserPaymentDelayed,
    loading,
    error,
  };
}
